import { api } from './client';

export interface TurkeyCity {
  id: number;
  name: string;
  plate: string;
}

export interface TurkeyDistrict {
  id: number;
  cityId: number;
  name: string;
  kolayGelsinDistrictId?: number;
}

export interface TurkeyNeighborhood {
  id: number;
  cityId: number;
  districtId: number;
  name: string;
  fullName?: string;
}

export const adminShippingLocationsApi = {
  getCities: async (): Promise<TurkeyCity[]> => {
    try {
      const res = await api.get<TurkeyCity[]>('/api/shipping/cities');
      return res && res.length > 0 ? res : [];
    } catch {
      return [];
    }
  },

  getDistricts: async (cityId: number): Promise<TurkeyDistrict[]> => {
    try {
      const res = await api.get<TurkeyDistrict[]>(`/api/shipping/districts/${cityId}`);
      return res && res.length > 0 ? res : [];
    } catch {
      return [];
    }
  },

  getNeighborhoods: async (cityId?: number, districtName?: string): Promise<TurkeyNeighborhood[]> => {
    try {
      const res = await api.get<TurkeyNeighborhood[]>('/api/shipping/neighborhoods', {
        cityId,
        districtName,
      });
      return res || [];
    } catch {
      return [];
    }
  },
};
